
    /**
    * 发送验证码
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid17419 {
  /**
   * (String)
   */
  mobile: string;
}
  /**
 * YResult :YResult
 */
export class IResid17419 {
  code?: {};
  msg?: {};
  success?: {};
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid17419, IResid17419 > = (data?) =>  request({
        method: 'POST',
        url: '/account/sms',
        data: data
      }) 
  export default http